﻿/* 
Object:         NAW
Description:    Logic and events for the module NAW / Adres
Used in:        Adres
*/

/*---[ ESLint ]---*/
/*
    global googlemaps
*/

window.naw = function () {

    return {

        /**
         * Init (binding button actions) Overview Adres
         */
        initialize: function () {
            // Create new record ...
            $("#editNaw").click(function (e) {

                // Prevent default behaviour
                e.preventDefault();

                // Edit mode form
                viewmode.setViewMode(ModuleActionViewEnum.Edit);

                // Load create form into the current module div 
                navigation.navigateToSpecificUrl("NAW/Edit");
            });
        },


        /**
         * Init Form Adres 
         * @param {any} googleMapsApiKey
         */
        initialize_form: function (googleMapsApiKey) {
            // Create new record ...
            $("#updateLocation").click(function (e) {

                // Prevent default behaviour
                e.preventDefault();

                // Get all input values
                var country = $("#CountryID").data("kendoDropDownList").text();
                var street = $('#Street').data("kendoTextBox").value();
                var number = $('#Number').data("kendoTextBox").value();
                var zip = $('#Zip').data("kendoTextBox").value();
                var city = $('#City').data("kendoTextBox").value();

                // Construct address to send
                var address = '';

                if (country.length > 0) {
                    address += country + ',';
                }
                if (street.length > 0) {
                    address += street + ' ';
                }
                if (number.length > 0) {
                    address += number + ',';
                }
                if (zip.length > 0) {
                    address += zip + ',';
                }
                if (city.length > 0) {
                    address += city + ',';
                }

                // Google Maps API key
                googlemaps.updateLonitudeLatitude(googleMapsApiKey, address);
            });
        }
    }
}();